import React, { useState } from 'react';
import { Card, CardBody, Col, Row, Input, FormGroup, Label, Form, Button } from 'reactstrap';
import Logo from '../../../components/navbar/Logo';
import Section from '../../../components/common/Section';
import bg1 from '../../../assets/img/generic/condominium.jpg';
import { PreloadState } from './../../UI/preloading/PreloadState';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import { APP_SETTINGS } from '../../../helpers/utils';
import { Toast } from '../../UI/toast/Toast';

const Contact = ({ match }) =>{
  
  const [ isLoading, setIsLoading ] = useState(false);

  const [names, setNames] = useState();
  const [email, seEmail] = useState();
  const [rol, setRol] = useState('Administrador');
  const [pais, setPais] = useState();
  const [city, setCity] = useState();
  const [candUnid, setCandUnid] = useState();
  const [phone, setPhone] = useState();
  const [enterprice, setEnterprice] = useState();
  const [detail, setDetail] = useState();

  const isSubmitting = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
        "name": names,
        "email": email,
        "rol": rol,
        "pais": pais,
        "ciudad": city,
        "numero_propiedades": candUnid,
        "phone": phone,
        "isRoot": 1,
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(`${APP_SETTINGS.API_URL}/lead`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json, text/plain, */*',
                },
                body: JSON.stringify(data),
            })
            const responseData = await response.json();
            if (responseData?.code === SUCCESS_RESPONSE.CREATED) {
                resolve(responseData);
                Toast.fire({
                  type: "success",
                  title: `Lead registrado exitosamente.`,
                });
            } else {
                reject(responseData);
            }
        } catch (error) {
            reject(error);
        }
    }).finally(() => {
        setIsLoading(false);
    });
}

  return  <>
          <Section id='contact' className="py-0 pt-4" image={bg1} style={{ backgroundSize: 'cover' }}  position="center bottom" overlay>
            <Row className="flex-center min-vh-100 py-6">
              <Col>
                <Row className='justify-content-center'>
                  <Col sm={12} className='text-center mb-4'>
                    <h2 className='col-12 text-center text-white'>¿Necesitas más información?</h2>
                  </Col>
                  <Col sm={12} md={10} lg={6}>
                    <Card>
                      <Logo to={'/'} classImage='mb-0 mt-4'/>
                        <CardBody className="fs--1 font-weight-normal p-5 pt-3">
                          <PreloadState loading={isLoading} message='Un momento, enviando información'>
                            <Form onSubmit={isSubmitting} className="text-left justify-content-between">
                              <Row>
                                <FormGroup tag={Col} sm={12}>
                                  <Label>NOMBRES Y APELLIDOS</Label>
                                  <Input 
                                    placeholder={'Nombres y apellidos'}
                                    onChange={({ target }) => setNames(target.value)}
                                  />
                                </FormGroup>
                              </Row>
                              <Row>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>CORREO</Label>
                                  <Input 
                                    placeholder={'Correo electrónico'}
                                    type={'email'}
                                    onChange={({ target }) => seEmail(target.value)}
                                  />
                                </FormGroup>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>ROL</Label>
                                  <Input 
                                    type='select'
                                    placeholder={'Rol'}
                                    onChange={({ target }) => setRol(target.value)}
                                  >
                                    <option>Administrador</option>
                                    <option>Propietario</option>
                                  </Input>
                                </FormGroup>
                              </Row>
                              <Row>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>PAIS</Label>
                                  <Input 
                                    placeholder={'País'}
                                    onChange={({ target }) => setPais(target.value)}
                                  />
                                </FormGroup>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>CIUDAD</Label>
                                  <Input 
                                    placeholder={'Ciudad'}
                                    onChange={({ target }) => setCity(target.value)}
                                  />
                                </FormGroup>
                              </Row>
                              <Row>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>PROPIEDADES EN TU COMUNIDAD</Label>
                                  <Input 
                                    type='number'
                                    placeholder={'123'}
                                    onChange={({ target }) => setCandUnid(target.value)}
                                  />
                                </FormGroup>
                                <FormGroup tag={Col} sm={6}>
                                  <Label>TELÉFONO</Label>
                                  <Input 
                                    placeholder={'Teléfono'}
                                    onChange={({ target }) => setPhone(target.value)}
                                  />
                                </FormGroup>
                              </Row>
                              <FormGroup>
                                <Button type='submit' color="primary" block className="mt-3">
                                  Enviar
                                </Button>
                              </FormGroup>
                            </Form>
                          </PreloadState>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Section>
        </>
}

export default Contact;